"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutatePositionAssign = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const positionAssignMutation = (0, graphql_tag_1.default) `
  mutation PositionAssign($workspaceId: ID!, $positionId: ID!, $userId: ID!, $contractId: ID!) {
    positionAssign(
      workspace: $workspaceId
      position: $positionId
      user: $userId
      contract: $contractId
    ) {
      positionId
    }
  }
`;
const mutatePositionAssign = async (variables) => {
    const { data, errors } = await (0, apollo_1.mutate)(positionAssignMutation, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.positionAssign;
};
exports.mutatePositionAssign = mutatePositionAssign;
